/**
 * Tokens de `relatorios_filtros.variavel` alinhados ao molde da fila (opção A — render dinâmico).
 */

/** Ordem de exibição sugerida (índice menor = primeiro). */
const ORDEM_TOKEN = [
  "${dt_inicial}",
  "${dt_final}",
  "${cnpj}",
  "${contas}",
  "${p_notas_saida}",
  "${p_prodid}",
  "${schema}",
];

/** Normaliza variável do catálogo para token canónico `${...}`. */
export function canonicalFilaCsvToken(variavel) {
  const s = String(variavel ?? "").trim();
  if (!s) return "";
  const lower = s.toLowerCase();
  const aliases = {
    "${dt_ini}": "${dt_inicial}",
    "${dt_fin}": "${dt_final}",
    "$f{dt_inicial}": "${dt_inicial}",
    "$f{dt_final}": "${dt_final}",
    "$f{dt_ini}": "${dt_inicial}",
    "$f{dt_fin}": "${dt_final}",
  };
  if (aliases[s]) return aliases[s];
  if (aliases[lower]) return aliases[lower];
  if (s.startsWith("${") && s.endsWith("}")) return s;
  return s;
}

/** Tipo lógico do campo para render. */
export function tokenFieldKind(canonical) {
  switch (canonical) {
    case "${dt_inicial}":
      return "dataInicial";
    case "${dt_final}":
      return "dataFinal";
    case "${cnpj}":
      return "cnpj";
    case "${contas}":
      return "contas";
    case "${p_notas_saida}":
      return "notasSaida";
    case "${p_prodid}":
      return "prodId";
    case "${schema}":
      return "schema";
    default:
      return "unknown";
  }
}

export function sortFiltrosFilaCsv(filtros) {
  if (!Array.isArray(filtros)) return [];
  return [...filtros].sort((a, b) => {
    const ca = canonicalFilaCsvToken(a?.variavel);
    const cb = canonicalFilaCsvToken(b?.variavel);
    const ia = ORDEM_TOKEN.indexOf(ca);
    const ib = ORDEM_TOKEN.indexOf(cb);
    const sa = ia === -1 ? ORDEM_TOKEN.length : ia;
    const sb = ib === -1 ? ORDEM_TOKEN.length : ib;
    if (sa !== sb) return sa - sb;
    return String(a?.nome ?? "").localeCompare(String(b?.nome ?? ""));
  });
}

